<template>
  <div :id="droparea_id" ref="drop-area" :class="classes" @mouseup="handleMouseup">

    <div v-if="placeholder">
      <p class="text-center">Släpp innehåll här</p>
    </div>
    <div v-else>
      <div class="editor-container" :id="editor_id">
        <!-- Panel with Delete and Copy icons -->
        <div class="top-right-panel">
          <button @click="copy_row_clicked">

            <span class="ml-svg-icon svg-icon-md svg-icon-primary-blue">
              <inline-svg src="/assets/svg/files.svg"></inline-svg>
            </span>
          
          </button>

          <button @click="delete_row_clicked">
            <span class="ml-svg-icon svg-icon-md svg-icon-primary-blue">
              <inline-svg src="/assets/svg/trash2.svg"></inline-svg>
            </span>
          
          </button>
          
        </div>
      </div>
      
      <div v-if="item.type === 'WebBuilderSurveyRadio'" class="radio-row">
        <p>Radio options</p>
      </div>
      <div v-if="item.type === 'WebBuilderSurveyCheckbox'" class="check-row">

        <WebBuilderSurveyCheckbox 
          :item="item"
          @edit_clicked="checkbox_edit_clicked"
        />

        <p class="add-row"><a>+ Lägg till svarsalternativ...</a></p>
        
        <div v-if="!selected" class="selectable-row" @click="selected = true">
          <p>this is some content in the row {{ index }} Y: {{ calcY }}, {{ rect }}</p>
          <p>scroll: {{ scroll }}</p>
        </div>
        
        <!--<component :is="component.type" :key="component.id" />-->
      </div>
      <!--<QuestionAsked 
        :item="item"
      />
      <div v-for="(column, index) in columns" :key="index" class="column">
        <slot :name="'column-' + index"></slot>
      </div>-->
    </div>

    <memlist-tiptap-compact
      ref="tiptap-floating-editor"
      class="inline-editor"
      v-model="edit_text"
      :enabled_tools="enabled_edit_tools"
    />

  </div>
</template>

<script>
import QuestionAsked from '@/view/components/questions/QuestionAsked.vue';
import WebBuilderSurveyCheckbox from './WebBuilderSurveyCheckbox.vue';
import { is_event_inside_element_with_id } from '@/core/services/editor.helper.js';

export default {
  name: 'WebBuilderLayoutRow',
  components: {
    QuestionAsked,
    WebBuilderSurveyCheckbox,
  },
  emits: ['on_mouse_up','header_update','option_update'],
  props: {
    show_placeholder: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: null,
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    editor_id() {
      return `ml-editor-${this.index}`;
    },
    droparea_id() {
      return `ml-droparea-${this.index}`;
    },
    scroll() {
      return { x: window.scrollX, y: window.scrollY };
    },
    rect() {
      const row = document.getElementById(this.droparea_id);
      if (row) {
        return JSON.stringify(row.getBoundingClientRect());
      }

      return null;
    },
    calcY() {
      const row = document.getElementById(this.droparea_id);
      if (row) {
        return row.getBoundingClientRect().scrollY;
      }

      return 0;
    },
    placeholder() {
      return !this.item || !this.item.type;
    },
    classes() {

      if (!this.show_placeholder && this.placeholder) {
        return ['invisible'];
      }

      if (this.placeholder) {
        return ['placeholder-row'];
      }

      return ['layout-row'];
    }
  },
  watch: {
    edit_text() {
      this.$emit('header_update', this.index, this.item, this.edit_text);
    },
  },
  mounted() {
    document.addEventListener('mousedown', this.handleClickOutside);
  },
  beforeDestroy() {
    // Clean up the event listener to prevent memory leaks
    document.removeEventListener('mousedown', this.handleClickOutside);
  },
  methods: {
    checkbox_edit_clicked(part, index) {
      
      // if part === 'header', its the header part
      // if part === 'question_text', its the text at each question, index tells us which question

      if (part === 'header') {
        
        this.edit_text = this.item.header || this.item.name;

        console.log('header edit', this.edit_text);
      }
      else {
        console.log('options', this.item);
        this.edit_text = this.item.options.find(i => i.index === index).text; // this.item.options[index].value || this.item.options[index].name;
      }

      this.$refs['tiptap-floating-editor'].show();
      
      console.log('checkbox_edit_clicked', part, index);
    },
    handleClickOutside(event) {
      if (!this.item.type) {
        return;
      }

      if (is_event_inside_element_with_id(event, this.editor_id)) {
        return;
      }

      this.selected = false;
    },

    handleMouseup(event) {
      // Get the drop-area element
      const dropArea = this.$refs['drop-area'];
      
      // Get the position and dimensions of the drop-area
      const rect = dropArea.getBoundingClientRect();
      
      // Check if mouse is inside the drop-area
      if (
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom
      ) {
        this.mouseup_triggered();
      }
    },
    mouseup_triggered() {
      console.log('Mouseup triggered inside the drop-area!');
      // Add your logic here

      this.$emit('on_mouse_up', this.index);
    },

    delete_row_clicked() {
      console.log('Delete row clicked');
      // Logic to delete the row
    },

    // Copy row method
    copy_row_clicked() {
      console.log('Copy row clicked');
      // Logic to copy the row
    }
  },
  data() { 
    return {
      enabled_edit_tools: {
        font: true,
        bold: true,
        italic: true,
        underline: true,
        strike: true,
      },
      edit_text: null,

      test_item: {
        id: 2,
        type: 'CHECKBOX',
        name: 'Vad möttes ni av?',
        options: [
          {
            text: '1',
            value: 1
          },
          {
            text: '2',
            value: 2
          },
        ]
      },

      selected: false,
      local_item: {
        header: 'test',
        options: [
          { text: 'hej', value: 1 }
        ]
      },
      question_asked: {
        id: 1,
        type: 'RADIO',
        name: 'Hur många gånger har du vandrat?',
        options: [
          {
            text: '1',
            value: 1
          },
          {
            text: 'Vill ej uppge',
            value: null
          }
        ]
      },
    }
  },
};
</script>

<style lang="css">
.placeholder-row {
  height: 36px;
  background-color: aquamarine;
  border: 1px dashed black;
  padding: 4px;
}

.layout-row {

}

.invisible {
  display: none;
}

.placeholder-row:hover {
  background-color: #e9e9e9;
}
.selectable-row:hover {
  border: 2px solid green;
}
.radio-row {
  min-height: 200px;
  background-color: #5c0bb8;
}
.check-row {
  min-height: 200px;
  background-color: #e26172;
}

.add-row {
  margin-left: 16px;
  margin-top: 4px;
  color: #085791;
  font-weight: 500;
}

.top-right-panel {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 10px;
  background-color: rgba(255, 255, 255, 0.7);
  padding: 5px;
  border-radius: 4px;
}

.top-right-panel button {
  background: transparent;
  border: none;
  cursor: pointer;
}

.top-right-panel svg {
  width: 20px;
  height: 20px;
  fill: #333;
}

.top-right-panel svg:hover {
  fill: #f00;
}

.editor-container {
  position: relative;
}

</style>
